import createEmotion from '@emotion/css/create-instance'

// Depends on <%= csp_meta_tag %> being present in ERB
const nonceEl = document.querySelector<HTMLMetaElement>('[name="csp-nonce"]')
const nonce = nonceEl ? nonceEl.content : null

export const { flush, hydrate, cx, merge, getRegisteredStyles, injectGlobal, keyframes, css, sheet, cache } =
  createEmotion({
    key: 'css',
    nonce,
  })
